import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { InAppNotification } from 'pure-js/types/InAppNotification'

interface InAppNotificationsState {
  notifications: InAppNotification[]
  loading: boolean
  error: string | null
}

const initialState: InAppNotificationsState = {
  notifications: [],
  loading: false,
  error: null
}

const inAppNotificationsSlice = createSlice({
  name: 'inAppNotifications',
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<InAppNotification[]>) => {
      state.notifications = action.payload
      state.loading = false
      state.error = null
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
      state.loading = false
    },
    markViewedLocally: (state, action: PayloadAction<string>) => {
      const n = state.notifications.find((n) => n.id === action.payload)
      if (n && !n.viewedAt) n.viewedAt = new Date().toISOString()
    },
    markAllViewedLocally: (state) => {
      const now = new Date().toISOString()
      state.notifications.forEach((n) => {
        if (!n.viewedAt) n.viewedAt = now
      })
    },
    addNotification: (state, action: PayloadAction<InAppNotification>) => {
      // Prepend; replace if same id already exists
      const idx = state.notifications.findIndex((n) => n.id === action.payload.id)
      if (idx !== -1) {
        state.notifications[idx] = action.payload
      } else {
        state.notifications.unshift(action.payload)
      }
    }
  }
})

export const { setNotifications, setLoading, setError, markViewedLocally, markAllViewedLocally, addNotification } =
  inAppNotificationsSlice.actions
export default inAppNotificationsSlice.reducer
